import React from "react";

const Car = () => (
  <svg
    version="1.1"
    id="Layer_3"
    x="0px"
    y="0px"
    viewBox="0 0 390 390"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M371.2,175.3l-3.7-12.1l-29.8-95.7c-5.8-18.6-22.9-31.2-42.4-31.2H94.7c-19.5,0-36.5,12.6-42.4,31.2l-29.8,95.7l-3.7,12.1
		C7.6,181.4,0,193.1,0,206.5v76.2c0,7.8,6.4,14.2,14.2,14.2h12.4v35.5c0,11.7,9.6,21.3,21.3,21.3H62c11.7,0,21.3-9.6,21.3-21.3
		v-35.5h223.4v35.5c0,11.7,9.6,21.3,21.3,21.3h14.2c11.7,0,21.3-9.6,21.3-21.3v-35.5h12.4c7.8,0,14.2-6.4,14.2-14.2v-76.2
		C390,193.2,382.4,181.4,371.2,175.3z M55,252.8c-14.7,0-26.6-11.9-26.6-26.6s11.9-26.6,26.6-26.6s26.6,11.9,26.6,26.6
		S69.7,252.8,55,252.8z M295.7,171.2c-9-14.9-25.4-24.8-44-24.8s-34.9,9.9-44,24.8H47.9l29.8-95.6c2.3-7.4,9.2-12.4,16.8-12.4h200.9
		c7.8,0,14.5,5,16.8,12.4l29.8,95.7L295.7,171.2z M335,252.8c-14.7,0-26.6-11.9-26.6-26.6s11.9-26.6,26.6-26.6
		c14.7,0,26.6,11.9,26.6,26.6S349.8,252.8,335,252.8z"
      />
      <circle cx="251.7" cy="107.4" r="33.7" />
    </g>
  </svg>
);

export default Car;
